export default "__VITE_ASSET__a7dddcd2__"